var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckOn = function SvgCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h18v18H3V3Zm1.39 1.39v15.22h15.22V4.39H4.39Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.412 14.37 6.65-6.7.987.979-7.636 7.695-4.462-4.496.987-.98 3.474 3.502Z",
    fill: "#000"
  })));
};
export { SvgCheckOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyAzSDIxVjIxSDNWM1pNNC4zOSA0LjM5VjE5LjYxSDE5LjYxVjQuMzlINC4zOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNDEyNSAxNC4zNzA1TDE3LjA2MiA3LjY2OTkyTDE4LjA0ODYgOC42NDkwM0wxMC40MTI1IDE2LjM0MzhMNS45NTA5MyAxMS44NDhMNi45Mzc1NSAxMC44Njg5TDEwLjQxMjUgMTQuMzcwNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";